module.exports = __webpack_public_path__ + "media/fonts/Roboto/Roboto-Light-d537674e9e217fa53a13cf9bcc7eaa62.woff2";